import axios from "axios";
import i18n from "../i18n";

const normalizeLang = (lang) => {
  const value = String(lang || "").toLowerCase();

  if (value === "fi") return "fin";
  if (value === "fin") return "fin";
  if (value === "lt") return "lt";
  if (value === "en") return "en";
  if (value === "ru") return "ru";

  return "lt";
};

export const auth = (email, password) => async (dispatch) => {
  const authData = {
    username: email,
    password,
  };

  try {
    await axios.post("./authentification", authData);

    const pendingLang = sessionStorage.getItem("pendingLoginLang");
    let selectedLang = null;

    if (pendingLang) {
      selectedLang = normalizeLang(pendingLang);

      try {
        await axios.put(
          `/api/user/lang/${selectedLang.toUpperCase()}`
        );

        sessionStorage.removeItem("pendingLoginLang");
      } catch (err) {
        console.error("Could not save selected language:", err);
      }
    }

    await dispatch(hideAuth("close-popup"));
    await dispatch(handleAlert(false));

    await dispatch(autoLogin(selectedLang));

    return true;
  } catch (err) {
    console.error(err);
    dispatch(handleAlert(true));
    return false;
  }
};

export const autoLogout = (time) => (dispatch) => {
  setTimeout(() => {
    dispatch(logout());
  }, time + 1000);
};

export const logout = () => {
  return {
    type: "AUTH_LOGOUT",
  };
};

export const autoLogin = (preferredLang = null) => async (dispatch) => {
  try {
    const response = await axios.get("/api/user");
    const details = response.data?.details;

    if (details?.username) {
      const lang = preferredLang
        ? normalizeLang(preferredLang)
        : details.lang
        ? normalizeLang(details.lang)
        : null;

      if (lang) {
        localStorage.setItem("lang", lang);
        await i18n.changeLanguage(lang);
      }

      dispatch(setAuthUsername(details.username));
    } else {
      dispatch(authChecked());
    }
  } catch (err) {
    console.error(err);
    dispatch(authChecked());
  }
};

export const authChecked = () => {
  return {
    type: "AUTH_CHECKED",
  };
};

export const setAuthUsername = (name) => {
  return {
    type: "SET_AUTH_USERNAME",
    payload: name,
  };
};

export const onChangeName = (e) => (dispatch) => {
  dispatch(changeName(e.target.value));
  dispatch(handleAlert(false));
};

export const changeName = (name) => {
  return {
    type: "SET_USER_NAME",
    payload: name,
  };
};

export const onChangePassword = (e) => (dispatch) => {
  dispatch(ChangePassword(e.target.value));
  dispatch(handleAlert(false));
};

export const ChangePassword = (password) => {
  return {
    type: "SET_USER_PASSWORD",
    payload: password,
  };
};

export const hideAuthHandler = (e) => (dispatch) => {
  dispatch(hideAuth(e.target.className));
  dispatch(handleAlert(false));
};

export const hideAuth = (className) => {
  if (className === "fade-for-click-auth" || className === "close-popup") {
    return {
      type: "AUTH_FORM_HIDE",
    };
  }

  return {
    type: "",
  };
};

export const handleAlert = (alert) => {
  return {
    type: "ALERT_STATUS",
    payload: alert,
  };
};